import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { Fragment } from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import estilos from '../Steps/StepsComponent.module.css'
import estilosTabs from '../Tabs/TabsInspeccionarComponent.module.css'
import { useEffect } from 'react';

function StepIngresoDeProduccionComponent(props) {

    const [informacionFormik, setInformacionFormik] = React.useState(
        {

        }
    );

    const [tabSelect, setTabSelect] = React.useState(0);
    const [tabsAdicionalDestilacion, setTabsAdicionalDestilacion] = React.useState([""]);

    const equipoCoccion = ['Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco'];

    const agregarTab = () => {
        if (tabsAdicionalDestilacion.length < 5) {
            setTabsAdicionalDestilacion([...tabsAdicionalDestilacion, ""])
        }
    }

    const seleccionarTab = (index) => {
        setTabSelect(index)
    }

    useEffect(() => {
        tabsAdicionalDestilacion
    }, [tabSelect, tabsAdicionalDestilacion])

    return (
        <Fragment>
            <Formik
                enableReinitialize={true}
                initialValues={informacionFormik}
                onSubmit={(valores) => {
                    console.log(valores)
                }}>
                {(props) => (
                    <Form>
                        <div className='row form-grou' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Datos generales de la Tapada o Producción</label>
                            <div className='col-11'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechaingreso'>Fecha de Ingreso</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="text" className="form-control form-control-sm" id="fechaingreso" name="fechaingreso" placeholder="Fecha de Ingreso" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='kilogramosentrada'>Kilogramos de Entrada</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="kilogramosentrada" name="kilogramosentrada" placeholder="Kilogramos de entrada" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='numerotapada'>Número de Tapada</label>
                                    </div>
                                    <div className="col">
                                        <Field type="text" className="form-control form-control-sm" id="numerotapada" name="numerotapada" placeholder="Número de tapada" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='art'>Azucares y Reductores Totales (ART)</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="art" name="art" placeholder="Azucares y Reductores Totales" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Cocción</label>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='equipococcion'>Equipo Utilizado</label>
                                    </div>
                                    <div className="col-6">
                                        <Field
                                            component="select"
                                            id="equipococcion"
                                            name="equipococcion"
                                            className="form-select"
                                            multiple={false}
                                            required
                                        >
                                            <option defaultValue>Equipo de Cocción</option>
                                            {equipoCoccion.map((t, index) => (
                                                <option key={index} value={t}>{t}</option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='tipococcion'>Tipo de Cocción</label>
                                    </div>
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-md-6 mb-6">
                                                <label htmlFor='piñas'>
                                                    <Field className="form-check-input" type="checkbox" name="piñas" id="piñas" />
                                                    <br />
                                                    <div className='text-black'> Cabezas o piñas de maguey</div>
                                                </label>
                                            </div>

                                            <div className="col-md-6 mb-6">
                                                <label htmlFor="jugos">
                                                    <Field className="form-check-input" type="checkbox" name="jugos" id="jugos" />
                                                    <br />
                                                    <div className='text-black'> Jugos de agave</div>

                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechainiciococcion'>Fecha de Inicio</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="date" className="form-control form-control-sm" id="fechainiciococcion" name="fechainiciococcion" placeholder="Fecha de Inicio" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechafinalcoccion'>Fecha Final</label>
                                    </div>
                                    <div className="col">
                                        <Field type="date" className="form-control form-control-sm" id="fechafinalcoccion" name="fechafinalcoccion" placeholder="Fecha Final" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Molienda</label>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='equipomolienda'>Equipo Utilizado</label>
                                    </div>
                                    <div className="col-6">
                                        <Field
                                            component="select"
                                            id="equipomolienda"
                                            name="equipomolienda"
                                            className="form-select"
                                            multiple={false}
                                            required
                                        >
                                            <option defaultValue>Equipo de Molienda</option>
                                            {equipoCoccion.map((t, index) => (
                                                <option key={index} value={t}>{t}</option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <br />
                            </div>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechainiciomolienda'>Fecha de Inicio</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="date" className="form-control form-control-sm" id="fechainiciomolienda" name="fechainiciomolienda" placeholder="Fecha de Inicio" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechafinalmolienda'>Fecha Final</label>
                                    </div>
                                    <div className="col">
                                        <Field type="date" className="form-control form-control-sm" id="fechafinalmolienda" name="fechafinalmolienda" placeholder="Fecha Final" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Formulación</label>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='equipoformulacion'>Equipo Utilizado</label>
                                    </div>
                                    <div className="col-6">
                                        <Field
                                            component="select"
                                            id="equipoformulacion"
                                            name="equipoformulacion"
                                            className="form-select"
                                            multiple={false}
                                            required
                                        >
                                            <option defaultValue>Equipo de Formulación</option>
                                            {equipoCoccion.map((t, index) => (
                                                <option key={index} value={t}>{t}</option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='volumenformulado'>Volumen Formulado</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="volumenformulado" name="volumenformulado" placeholder="Volumen Formulado" required />
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechainicioformulacion'>Fecha de Inicio</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="date" className="form-control form-control-sm" id="fechainicioformulacion" name="fechainicioformulacion" placeholder="Fecha de Inicio" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechafinalformulacion'>Fecha Final</label>
                                    </div>
                                    <div className="col">
                                        <Field type="date" className="form-control form-control-sm" id="fechafinalformulacion" name="fechafinalformulacion" placeholder="Fecha Final" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Destilación</label>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='equipodestilacion'>Equipo Utilizado</label>
                                    </div>
                                    <div className="col-6">
                                        <Field
                                            component="select"
                                            id="equipodestilacion"
                                            name="equipodestilacion"
                                            className="form-select"
                                            multiple={false}
                                            required
                                        >
                                            <option defaultValue>Equipo de Destilación</option>
                                            {equipoCoccion.map((t, index) => (
                                                <option key={index} value={t}>{t}</option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='numerodestilaciones'>Numero de Destilaciones</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="numerodestilaciones" name="numerodestilaciones" placeholder="Numero de destilaciones" required />
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechainiciodestilacion'>Fecha de Inicio</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="date" className="form-control form-control-sm" id="fechainiciodestilacion" name="fechainiciodestilacion" placeholder="Fecha de Inicio" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='fechafinaldestilacion'>Fecha Final</label>
                                    </div>
                                    <div className="col">
                                        <Field type="date" className="form-control form-control-sm" id="fechafinaldestilacion" name="fechafinaldestilacion" placeholder="Fecha Final" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Adicional a Destilación</label>
                            <div className="row">

                            </div>
                            <FieldArray
                                name='validacionguias'
                                render={arrayHelpers => (
                                    <div className="row">
                                        <div style={{ textAlign: "center" }}>
                                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={agregarTab}>+ </button>
                                        </div>
                                        {
                                            tabsAdicionalDestilacion.map((g, index) => (
                                                <div className='col' key={index}>
                                                    <button type="button" onClick={() => seleccionarTab(index)} className={`btn btn-light ${estilosTabs.block}`} style={{ background: '#0e813c', color: 'black' }}>{index + 1}</button>
                                                    <br />
                                                </div>
                                            ))
                                        }

                                        {
                                            tabSelect === 0 ?
                                                <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                                    <label>{tabSelect}</label>
                                                    <div className='col-6'>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col">
                                                                <label htmlFor={`adicional.${tabSelect}.volumen`}>Volumen</label>
                                                            </div>
                                                            <div className="col-6">
                                                                <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.volumen`} name={`adicional.${tabSelect}.volumen`} placeholder="Volumen" required />
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col">
                                                                <label htmlFor={`adicional.${tabSelect}.gradoalcoholico`}>Grado Alcoholico</label>
                                                            </div>
                                                            <div className="col">
                                                                <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.gradoalcoholico`} name={`adicional.${tabSelect}.gradoalcoholico`} placeholder="Grado Alcoholico" required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : tabSelect === 1 ?
                                                    <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                                        <label>{tabSelect}</label>
                                                        <div className='col-6'>
                                                            <br />
                                                            <div className="row">
                                                                <div className="col">
                                                                    <label htmlFor={`adicional.${tabSelect}.volumen`}>Volumen</label>
                                                                </div>
                                                                <div className="col-6">
                                                                    <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.volumen`} name={`adicional.${tabSelect}.volumen`} placeholder="Volumen" required />
                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div className="row">
                                                                <div className="col">
                                                                    <label htmlFor={`adicional.${tabSelect}.gradoalcoholico`}>Grado Alcoholico</label>
                                                                </div>
                                                                <div className="col">
                                                                    <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.gradoalcoholico`} name={`adicional.${tabSelect}.gradoalcoholico`} placeholder="Grado Alcoholico" required />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : tabSelect === 2 ?
                                                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                                            <label>{tabSelect}</label>
                                                            <div className='col-6'>
                                                                <br />
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <label htmlFor={`adicional.${tabSelect}.volumen`}>Volumen</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.volumen`} name={`adicional.${tabSelect}.volumen`} placeholder="Volumen" required />
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <label htmlFor={`adicional.${tabSelect}.gradoalcoholico`}>Grado Alcoholico</label>
                                                                    </div>
                                                                    <div className="col">
                                                                        <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.gradoalcoholico`} name={`adicional.${tabSelect}.gradoalcoholico`} placeholder="Grado Alcoholico" required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : tabSelect === 3 ?
                                                            <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                                                <label>{tabSelect}</label>
                                                                <div className='col-6'>
                                                                    <br />
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <label htmlFor={`adicional.${tabSelect}.volumen`}>Volumen</label>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.volumen`} name={`adicional.${tabSelect}.volumen`} placeholder="Volumen" required />
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <label htmlFor={`adicional.${tabSelect}.gradoalcoholico`}>Grado Alcoholico</label>
                                                                        </div>
                                                                        <div className="col">
                                                                            <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.gradoalcoholico`} name={`adicional.${tabSelect}.gradoalcoholico`} placeholder="Grado Alcoholico" required />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : tabSelect === 4 ?
                                                                <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                                                    <label>{tabSelect}</label>
                                                                    <div className='col-6'>
                                                                        <br />
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <label htmlFor={`adicional.${tabSelect}.volumen`}>Volumen</label>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.volumen`} name={`adicional.${tabSelect}.volumen`} placeholder="Volumen" required />
                                                                            </div>
                                                                        </div>
                                                                        <br />
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <label htmlFor={`adicional.${tabSelect}.gradoalcoholico`}>Grado Alcoholico</label>
                                                                            </div>
                                                                            <div className="col">
                                                                                <Field type="text" className="form-control form-control-sm" id={`adicional.${tabSelect}.gradoalcoholico`} name={`adicional.${tabSelect}.gradoalcoholico`} placeholder="Grado Alcoholico" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div></div>
                                        }
                                    </div>
                                )}
                            />
                        </div>
                        <button type='submit'>asd</button>
                    </Form>
                )}
            </Formik>
        </Fragment>
    )

}
export default withRouter(StepIngresoDeProduccionComponent)